"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var UL = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.featureList.container; });
var LI = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.featureList.item; });
var FeatureList = /** @class */ (function (_super) {
    __extends(FeatureList, _super);
    function FeatureList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureList.prototype.render = function () {
        return (react_1.default.createElement(UL, { className: this.props.className },
            this.props.features &&
                react_1.default.Children.map(this.props.features, this.renderItem),
            this.props.children &&
                react_1.default.Children.map(this.props.children, this.renderItem)));
    };
    FeatureList.prototype.renderItem = function (node, index) {
        return (react_1.default.createElement(LI, { key: index }, node));
    };
    FeatureList.propTypes = {
        features: prop_types_1.default.node,
        children: prop_types_1.default.node
    };
    FeatureList.defaultProps = {};
    return FeatureList;
}(react_1.Component));
exports.default = styled_components_1.withTheme(FeatureList);
var templateObject_1, templateObject_2;
//# sourceMappingURL=FeatureList.js.map